import { IPutioAPIClientOptions } from './client/types'

export const DEFAULT_CLIENT_OPTIONS: IPutioAPIClientOptions = {
  baseURL: 'https://api.put.io/v2',
  clientID: 1,
  webAppURL: 'https://app.put.io',
}
